<div class="ps-grid-2-col">
  <div>Sequenz</div>
  <div>{{sequenceDescription}}</div>
  <div>Objekt</div>
  <div>{{objectName}} {{objectDescription}}</div>
</div>

<button mat-button (click)="confirm();">BESTÄTIGEN</button>
<button mat-button (click)="dismiss();">ABBRECHEN</button>
